module.exports = __webpack_public_path__ + "img/osint-logo.40d7c347.png";